import { render, staticRenderFns } from "./UrgentNotificationsCard.vue?vue&type=template&id=4b782217&scoped=true&"
import script from "./UrgentNotificationsCard.vue?vue&type=script&lang=js&"
export * from "./UrgentNotificationsCard.vue?vue&type=script&lang=js&"
import style0 from "./UrgentNotificationsCard.vue?vue&type=style&index=0&id=4b782217&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b782217",
  null
  
)

export default component.exports